export default __webpack_public_path__ + "static/search-85c53ea5e70d8d2f865aa419066faa5d.png";